import * as yup from 'yup';
import { DateTime } from 'luxon';

export const reissueDiscountValidation = yup.object().shape({
  priorLoanDate: yup
    .string()
    .test(
      'priorLoanDate',
      'Enter a valid date',
      (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
    )
    .nullable()
    .required(),
  priorLoanAmount: yup.number().nullable().required(),
  payoffBalance: yup.number().nullable().required(),
});
